<div class="mat-elevation-z8 tableWrapper" >
  <table mat-table #table [dataSource]="dataSource" matSort aria-label="Elements">
    <!-- Column -->
    <ng-container matColumnDef="user">
      <th mat-header-cell *matHeaderCellDef>申請者</th>
      <td mat-cell center-cell *matCellDef="let row">{{row?.userName}}</td>
    </ng-container>
    <ng-container matColumnDef="timeStamp">
      <th mat-header-cell *matHeaderCellDef>対象年月日</th>
      <td mat-cell center-cell *matCellDef="let row">{{row?.targetDate.toLocaleDateString()}}</td>
    </ng-container>
    <ng-container matColumnDef="actual">
      <th mat-header-cell *matHeaderCellDef>実打刻</th>
      <td class="actual-stamp-table" mat-cell left-cell *matCellDef="let row"><app-actual-stamp-table [reportRecord]="row"></app-actual-stamp-table></td>
    </ng-container>
    <ng-container matColumnDef="request">
      <th mat-header-cell *matHeaderCellDef>申請 (<span class="addtional">青字</span>:追加, <span class="ejected">取り消し赤字</span>:打刻取消)</th>
      <td class="change-stamp-table" mat-cell left-cell *matCellDef="let row"><app-change-stamp-table [reportRecord]="row"></app-change-stamp-table></td>
    </ng-container>
    <ng-container matColumnDef="cause">
      <th mat-header-cell *matHeaderCellDef>理由</th>
      <td mat-cell center-cell *matCellDef="let row">{{row?.cause}}</td>
    </ng-container>
    <ng-container matColumnDef="approveAction">
      <th mat-header-cell *matHeaderCellDef>操作</th>
      <td mat-cell center-cell *matCellDef="let row">
        <button mat-stroked-button color="primary" (click)="onApprove(row,1)">承認</button>
        <button mat-stroked-button color="accent" (click)="onApprove(row,2)">却下</button>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator class="paginator" #paginator [length]="dataSource?.data?.length" [pageIndex]="0" [pageSize]="50" [pageSizeOptions]="[25, 50, 100, 250]">
  </mat-paginator>
</div>
